module.exports = __webpack_public_path__ + "static/media/996580.adc9248e.png";